import {EndPoint} from '$lib/utils/graphql/endpoint';
import {graphNodeURL} from '$lib/config';

export const SUBGRAPH_ENDPOINT = new EndPoint(graphNodeURL);
